import { createContext } from "react";

const ContextStates = createContext();

export default ContextStates;